<closeable-dialog class="ocppChargePoint-dialog-container">
  <div class="dialog-header" dialog-card-header>
    <label> {{ 'Charge Station' | translate }} </label>
    <label *ngIf="connectorCount > 0" class="header-info" [ngClass]="ocppStyle"> {{ ocppStatus | translate }} </label>
  </div>
  <div dialog-card-body class="dialog-body full-height">
    <nb-tabset *ngIf="connectorCount > 1" (changeTab)="onTabChange($event)">
      <nb-tab
        *ngFor="let ocppConn of ocppConnectors; let i = index" [tabId]="ocppConn.ocppConnectorId" tabTitle="{{connectorNumbers[i]}}"
        [tabIcon]="{icon:ocppConn.ocppIcon, options:{color:ocppConn.ocppIconColor}}"
        responsive>
      </nb-tab>
    </nb-tabset>
    <div class="d-flex" *ngIf="connectorCount > 0">
      <div class="centered-image">
        <img *ngIf="connectorNumbers[activeConnectorNo] === '1'" class="img1" src="assets/images/SarjDiregi_Samsun.svg" width="202" height="193">
        <img *ngIf="connectorNumbers[activeConnectorNo] !== '1'" class="img1" src="assets/images/Resim_SarjIstasyonu.svg" width="172" height="146">
      </div>
      <div class="status-shape">
        <div class="circle" [ngStyle]="{'background': outerBackground}">
          <div class="circle-inner" [ngStyle]="{'color': statusColor}">
            <div *ngIf="ocppStatus === 'Charging'" class="ocpp-status">% {{ocppConnectors[activeConnectorNo].socValue}}</div>
            <div *ngIf="ocppStatus === 'Charging'" class="charging-time">{{chargeTime}}</div>
            <div *ngIf="ocppStatus !== 'Charging'">
              <img src="{{ocppStatusDescriptionIcon}}">
            </div>
          </div>
        </div>
        <div class="below-status"> </div>
        <div [ngStyle]="{'height': '5vh'}" class="no-padding-margin">
          <label *ngIf="ocppStatus === 'Charging' || ocppStatus === 'SuspendedEVSE' || ocppStatus === 'SuspendedEV'" class="column-title no-padding-margin"> {{vin}}</label>
          <label class="column-info no-padding-margin"> {{ocppStatusDetail | translate }}</label>
        </div>
      </div>
    </div>
    <div class="no-connector" *ngIf="connectorCount === 0">
      <div> {{ 'Receiving Data' | translate }} </div>
      <div [ngStyle]="{'font-style': 'italic'}"> {{ 'Please Wait' | translate }} </div>
    </div>
    <div class="general-info">
        <div class="d-flex">
          <label class="column-title">{{ 'General Information' | translate }}: </label>
        </div>
        <div class="d-flex">
          <label class="column-info title">{{ 'chargePointVendor' | translate }} : </label>
          <label class="column-info content">{{vendor}}</label>
        </div>
        <div class="d-flex">
          <label class="column-info title">{{ 'chargePointModel' | translate }} :</label>
          <label class="column-info content">{{modelNo}}</label>
        </div>
        <div class="d-flex">
          <label class="column-info title">{{ 'chargePointSerialNumber' | translate }} :</label>
          <label class="column-info content">{{serialNumber}}</label>
        </div>
        <div class="d-flex">
          <label class="column-info title">{{ 'firmwareVersion' | translate }} :</label>
          <label class="column-info content">{{firmware}}</label>
        </div>
    </div>
  </div>
  <div dialog-card-footer class="footer">
    <div class="footer-left">
      <label class="column-info title">{{'coordinate' | translate}}: </label>
      <label class="column-info content">{{location}}</label>
    </div>
  </div>
</closeable-dialog>

